// @ts-ignore
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
// 注意：本文件会被 `yarn api` 重新生成（基于后端 /api/docs-json），
// 新增或删除 API 模块时，跑一次 `yarn api` 会自动同步这里的 imports。
import * as auth from "./auth";
import * as dict from "./dict";
import * as role from "./role";
import * as permission from "./permission";
import * as user from "./user";
import * as log from "./log";
import * as errorLog from "./errorLog";
import * as file from "./file";
import * as cms from "./cms";

export default {
  auth,
  dict,
  role,
  permission,
  user,
  log,
  errorLog,
  file,
  cms,
};
